import { Component, OnInit, Input } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
interface menu {
  text: string,
  route: string
}

@Component({
  selector: 'app-menu-modulo',
  templateUrl: './menu-modulo.component.html',
  styleUrls: ['./menu-modulo.component.scss']
})

export class MenuModuloComponent implements OnInit {

  @Input() menu: menu[];
  public lastPath: string;

  constructor(private router: Router) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        let path = event.urlAfterRedirects.split('/');
        this.lastPath = path.pop();
      }
    })
  }

  ngOnInit() { }
}
